import isUndefined from 'lodash/isUndefined';
import * as React from 'react';
import { Form, Input, Layout, Modal } from 'ssc-ui-react';

import { $gt } from '@/common/appCtx';

export const useSmallBufferConfig = () => {
  const [form] = Form.useForm();
  const ref = React.useRef<any>(null);

  const clockInMax = Form.useWatch('clock_in', form);
  const clockOutMax = Form.useWatch('clock_out', form);

  const isInValid = React.useMemo(() => {
    return !/^\d+$/.test(clockInMax) || !/^\d+$/.test(clockOutMax);
  }, [clockInMax, clockOutMax]);

  React.useEffect(() => {
    ref.current?.update({
      okButtonProps: {
        disabled: isInValid,
      },
    });
  }, [clockInMax, clockOutMax, isInValid]);

  const showSmallBufferConfig = React.useCallback(() => {
    ref.current = Modal.confirm({
      title: $gt('Small buffer Config'),
      content: (
        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item
            required
            name="clock_in"
            label={$gt('The maximum can be late for clock-in')}
            rules={[{ required: true, message: $gt('Please input the maximum can be late for clock-in') }]}
          >
            <Layout.Blocks direction="horizontal">
              <Input suffix={$gt('Hours')} onChange={value => form.setFieldValue('clock_in', value)} />
              <Input suffix={$gt('Mins')} onChange={value => form.setFieldValue('clock_in', value)} />
            </Layout.Blocks>
          </Form.Item>
          <Form.Item
            required
            name="clock_out"
            label={$gt('The maximum can be late for clock-out')}
            rules={[{ required: true, message: $gt('Please input the maximum can be late for clock-out') }]}
          >
            <Layout.Blocks direction="horizontal">
              <Input suffix={$gt('Hours')} onChange={value => form.setFieldValue('clock_out', value)} />
              <Input suffix={$gt('Mins')} onChange={value => form.setFieldValue('clock_out', value)} />
            </Layout.Blocks>
          </Form.Item>
        </Form>
      ),
      okButtonProps: {
        disabled: isInValid,
      }
    });
  }, [form, isInValid]);

  return {
    showSmallBufferConfig,
  };
};
